import { render, staticRenderFns } from "./nota.vue?vue&type=template&id=2a702c3e"
import script from "./nota.vue?vue&type=script&lang=js"
export * from "./nota.vue?vue&type=script&lang=js"
import style0 from "./nota.vue?vue&type=style&index=0&id=2a702c3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports